var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parag"},[_vm._l((_vm.item.customizable_content),function(paragraph){return [_c(_vm.paragType[paragraph.type],{key:paragraph.id,tag:"component",attrs:{"paragraph":paragraph}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }